import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Linkedin } from 'lucide-react';

const teamMembers = [
  {
    name: 'Stéphane Revil',
    role: 'Managing Partner',
    image: 'https://cdn.prod.website-files.com/65bab6e8de90f51ce337cb55/65bac163c94e137b1321e69b_Design%20sans%20titre%20(6).png',
    linkedin: 'https://www.linkedin.com/in/st%C3%A9phane-revil-74926b21/',
  },
  {
    name: 'Mattéo Nathan',
    role: 'Co-Founder & Acquisitions',
    image: 'https://static.prod-images.emergentagent.com/jobs/c1f6dc83-8b62-48dc-b396-cdfb9fb68a18/images/618eca05f855be904af3c92a02648d5e88520c2ffa493c716d7efce6c5f53066.jpeg',
    linkedin: 'https://www.linkedin.com/in/matt%C3%A9o-nathan-759454157/',
  },
  {
    name: 'Terence Dossou',
    role: 'Co-Founder & Fundraising',
    image: 'https://static.prod-images.emergentagent.com/jobs/c1f6dc83-8b62-48dc-b396-cdfb9fb68a18/images/c1446eb465a4e0b2f96398f3178e505610f1f10668ed80c55b1e4127f24c41e3.jpeg',
    linkedin: 'https://www.linkedin.com/in/terence-dossou-5a3067160/',
    imagePosition: 'object-[center_20%]',
  },
];

export const TeamSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="py-24 md:py-32 bg-[#050505]" data-testid="team-section">
      <div className="container-custom">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-16"
        >
          <div>
            <span className="overline mb-4 block">Notre équipe</span>
            <h2 className="text-3xl md:text-5xl font-medium">
              L'Équipe <span className="text-gradient">Second Souffle</span>
            </h2>
          </div>
          <Link
            to="/about"
            className="mt-6 md:mt-0 flex items-center gap-2 text-[#D4AF37] hover:text-[#F3E5AB] transition-colors font-medium"
            data-testid="team-see-all-link"
          >
            Voir tous les membres
            <ArrowRight size={18} />
          </Link>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="team-card card-hover aspect-[3/4]"
              data-testid={`team-member-${index}`}
            >
              <img
                src={member.image}
                alt={member.name}
                className={`w-full h-full object-cover ${member.imagePosition || ''}`}
              />
              <div className="team-card-content">
                <h3 className="text-xl font-medium text-white mb-1">
                  {member.name}
                </h3>
                <div className="flex items-center justify-between">
                  <p className="text-[#D4AF37] text-sm">{member.role}</p>
                  <a 
                    href={member.linkedin} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-white/60 hover:text-[#D4AF37] transition-colors"
                    aria-label={`LinkedIn de ${member.name}`}
                  >
                    <Linkedin size={18} />
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
